import merge from 'lodash.merge';
import { ANWBBrandRefreshThemeCurrent } from './current';
import { ANWBBrandRefreshThemeV9 } from './v9';
import { ANWBBrandRefreshThemeV10 } from './v10';
export const ANWBBrandRefreshTheme = merge(ANWBBrandRefreshThemeV9, ANWBBrandRefreshThemeV10, ANWBBrandRefreshThemeCurrent);
//# sourceMappingURL=anwb-brand-refresh-theme.js.map